<script setup>
import {computed, defineAsyncComponent} from "vue";

const props = defineProps({
  href: String,
  label: String,
  icon: String | null,
  svg: String | null
});

let component = null;

if (props.svg) {
  component = computed(
    () => defineAsyncComponent(() => import(`@/Components/Common/Svg/${props.svg}.vue`))
  );
}
</script>

<template>
  <a :href="href" class="block">
    <div class="p-2 bg-white shadow sm:rounded-md text-center">
      <div class="bg-cyan-500 rounded-2xl shadow-inner w-24 h-24 mx-auto p-2">
        <div class="bg-white bg-opacity-30 rounded-2xl shadow-inner w-20 h-20 p-5">
          <span class="fa text-4xl text-white" :class="`fa-${icon}`" v-if="icon"></span>

          <component v-if="svg" :is="component" class="w-10 h-10" color="#fff"></component>
        </div>
      </div>
      <span class="block text-l mt-1 font-bold text-gray-700" v-text="label"></span>
    </div>
  </a>
</template>
